import React from 'react'

function AnswerTab() {
  return (
    <div>AnswerTab</div>
  )
}

export default AnswerTab